import { createStore } from 'vuex'
import axios           from 'axios'

import dictionaryUsersHead from '@/store/modules/dictionary/usersHead'
import dictionaryAccount   from '@/store/modules/dictionary/accountants'
import dictionaryTerm      from '@/store/modules/dictionary/terminals'
import dictionaryUsers     from '@/store/modules/dictionary/users'
import dictionaryDep       from '@/store/modules/dictionary/departments'
import regions           from '@/store/modules/dictionary/regions'
import branchDepartments from '@/store/modules/branch/departments'
import branchSignatories from '@/store/modules/branch/signatories'
import branchEmployees   from '@/store/modules/branch/employees'
import branchTerminals   from '@/store/modules/branch/terminals'
import branchesModel     from '@/store/modules/branch/branchesModel'
import terminals         from '@/store/modules/terminals'
import version           from '@/store/modules/versions'
import avr               from '@/store/modules/avr'
import bpmWizard         from '@/store/modules/bpm/wizard'

export default createStore({
  state: {
    employees:    null,
    deleted:      null,
    user:         null,
    agreements:   null,
    globalPolicyModalShow: false,
    terminationPolicyModalShow: false,
    rewritePolicyModalShow: false,
    layoutPageTitle: null,
  },
  getters: {
    getDeleted(state) {
      return state.deleted
    },
    getUser(state) {
      return state.user
    }
  },
  mutations: {
    setDeleted(state, data) {
      return state.deleted = data
    },
    setUser(state, data) {
      return state.user = data
    },
    setAgreements(state, data) {
      return state.agreements = data
    },
    setGlobalPolicyModalShow(state, data) {
      return state.globalPolicyModalShow = data
    },
    setTerminationPolicyModalShow(state, data) {
      return state.terminationPolicyModalShow = data
    },
    setRewritePolicyModalShow(state, data) {
      return state.rewritePolicyModalShow = data
    },
    setLayoutPageTitle(state, title) {
      return state.layoutPageTitle = title
    },
  },
  actions: {
    deletedRequest(context) {
      axios.get('/api/employees/deleted')
          .then(res => {
            context.commit('setDeleted', res.data)
          })
    },
    userRequest(context, data) {
      context.commit('setUser', data)
    },
    agreementsRequest(context) {
      return axios.get('/api/agreement/my-agreements')
          .then(res => {
            if (res.data) context.commit('setAgreements', res.data)
          })
    },
  },
  modules: {
    branchSignatories,
    branchDepartments,
    branchTerminals,
    branchEmployees,
    branchesModel,
    dictionaryUsersHead,
    dictionaryAccount,
    dictionaryUsers,
    dictionaryTerm,
    dictionaryDep,
    terminals,
    version,
    regions,
    avr,
    bpmWizard,
  }
})
